import { EvaluationStatus } from "@/evaluations/entities/evaluation-status"

export function isDraft(status: EvaluationStatus) {
  return status === EvaluationStatus.Draft
}

export function isInProgress(status: EvaluationStatus) {
  return status === EvaluationStatus.InProgress
}

export function isFinished(status: EvaluationStatus) {
  return status === EvaluationStatus.Finished
}
